// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-videos {
    margin-top: 50px;
}

.custom-container {
    padding-left: 8%;
    padding-right: 8%;
}

.custom-container h5 {
    font-size: 17px;
    margin-bottom: 10px;
    font-weight: 600;
}

.custom-container h3 {
    color: #a6a3a3;
    font-size: 14px;
    margin-bottom: 30px;
    font-weight: 400;
}

.custom-container p {
    color: #a6a3a3;
    font-size: 14px;
    margin-bottom: 0px!important;
}

.custom-container p > span {
    color: #6c2fbb;
}

/*.video-container {*/
/*    padding: 10px;*/
/*}*/

/*.video-container:hover {*/
/*    background-color: #FFF;*/
/*    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.5)*/
/*}*/

/*.video-container:hover .published-options {*/
/*    display: block;*/

/*}*/

/*.video-container:hover .published-options p,*/
/*.video-container:hover .published-options h5 {*/
/*    color: #878787;*/
/*}*/

/*.video-container:hover .published-views {*/
/*    display: none;*/
/*}*/

.published-options {
    /* display: none; */
    list-style-type: none;
}

.published-options p, h5 {
    color: #000000;
}

.published-options p {
    margin-bottom: 0px;
    margin-top: 0;
}

.published-options h5 {
    margin-top: 0;
    margin-bottom: 35px;
}

.published-options li a:hover {
    color: #6c2fbb;
}


h5 {
    margin-top: 15px;
}

.poster {
    /*width: 100%;*/
    /* height: 100%; */
    cursor: pointer;
}

/***********************new************************/
.video-title {
    /*margin-bottom: 20px;*/
    font-weight: 500;
    font-size: 20px;
    margin-top: 10px;
}

.cateogyclass {
    padding: 5px 17px;
    margin-top: 10px;
    font-size: 14px;
    font-weight: 400;
    background: #FFFFFF;
    border-radius: 12px;
}

.tab-box-video {
    width: 100%;

}

.tab-box-video ul {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
}

.tab-box-video ul li {
    list-style: none;
    font-weight: 500;
    font-size: 18px;
    padding: 5px 0;
    margin: 0px 25px;
    color: #878395;
    cursor: pointer;
}

.tab-box-video ul li svg {
    fill: #878395;
}

.tab-box-video ul li.active {
    border-top: 3px solid #6c2fbb;
    color: #6c2fbb;
}

.tab-box-video ul li.active svg {
    fill: rgba(108, 47, 187, 1);
}

.video-container {
    padding: 30px;
    border-radius: 10px;
    background-color: #ffff;
    height: 66vh;
    /*margin-top: 40px;*/
    overflow-y: auto;
    overflow-x: hidden;
}

.img-box-pub {
    aspect-ratio: 16/9;
    display: flex;
    justify-content: center;
    /*height: 213px;*/
    position: relative;
    overflow: hidden;
    background: #f8f9fa;
    border-radius: 10px;
    width: 100%;
}

.img-box-pub img {
    height: 100%;
    object-fit: cover;
    cursor: pointer;
}

.two-btns {
    position: absolute;
    top: 0;
    right: 0;
    background-color: #000000a2;
    display: flex;
    align-items: center;
    -moz-column-gap: 10px;
         column-gap: 10px;
    padding: 2px 10px;
    border-radius: 5px 10px;
}

.two-btns button {
    background-color: transparent;
    display: flex;
    align-items: center;
    -moz-column-gap: 5px;
         column-gap: 5px;
    border: none;
}

.two-btns button span {
    color: #fff;
    font-size: 17px !important;
}

.width-100 {
    width: 100%;
    padding: 15px 0;
    margin: 5px 0;
    cursor: pointer;
}

.width-100:hover {
    background-color: #f8f9fa;
    box-shadow: 0 0 2px 0 rgb(0 0 0 / 50%);
}

@media (max-width: 1600px) {

    .img-box-pub {
        height: 150px
    }

}

@media (max-width: 1400px) {
    .group-box .two-btns {
        position: absolute;
        top: 5px;
        right: 5px;

    }

    .group-box .two-btns button span {
        font-size: 15px !important;
    }

    .tab-box-video ul li {
        font-size: 18px;
        white-space: nowrap;
    }

    .img-box-pub {
        height: 120px;
    }

    .video-title {
        font-size: 18px;
    }
}

@media (max-width: 1200px) {
    .tab-box-video ul {
        overflow-x: auto;
        padding-bottom: 10px;

    }

    .tab-box-video ul::-webkit-scrollbar {
        height: 7px;
    }


}

@media (max-width: 991px) {

    .video-container {
        padding: 12px;
    }

    .img-box-pub {
        height: 240px;
    }
}

@media (max-width: 768px) {

    .tab-box-video ul li {
        font-size: 17px;
    }

    .img-box-pub {
        height: 157px;
    }

    .video-title {
        font-size: 17px;
    }
}

@media (max-width: 420px) {
    .video-title {
        font-size: 15px;
    }

    .img-box-pub {
        height: 180px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/new-my-videos-public/new-my-videos-public.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA,qBAAqB;AACrB,qBAAqB;AACrB,IAAI;;AAEJ,2BAA2B;AAC3B,8BAA8B;AAC9B,qDAAqD;AACrD,IAAI;;AAEJ,8CAA8C;AAC9C,sBAAsB;;AAEtB,IAAI;;AAEJ,+CAA+C;AAC/C,iDAAiD;AACjD,sBAAsB;AACtB,IAAI;;AAEJ,4CAA4C;AAC5C,qBAAqB;AACrB,IAAI;;AAEJ;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;;AAGA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;;AAEA,mDAAmD;AACnD;IACI,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;;AAEf;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,qBAAgB;SAAhB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,oBAAe;SAAf,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,sCAAsC;AAC1C;;AAEA;;IAEI;QACI;IACJ;;AAEJ;;AAEA;IACI;QACI,kBAAkB;QAClB,QAAQ;QACR,UAAU;;IAEd;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,oBAAoB;;IAExB;;IAEA;QACI,WAAW;IACf;;;AAGJ;;AAEA;;IAEI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;;IAEI;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".my-videos {\n    margin-top: 50px;\n}\n\n.custom-container {\n    padding-left: 8%;\n    padding-right: 8%;\n}\n\n.custom-container h5 {\n    font-size: 17px;\n    margin-bottom: 10px;\n    font-weight: 600;\n}\n\n.custom-container h3 {\n    color: #a6a3a3;\n    font-size: 14px;\n    margin-bottom: 30px;\n    font-weight: 400;\n}\n\n.custom-container p {\n    color: #a6a3a3;\n    font-size: 14px;\n    margin-bottom: 0px!important;\n}\n\n.custom-container p > span {\n    color: #6c2fbb;\n}\n\n/*.video-container {*/\n/*    padding: 10px;*/\n/*}*/\n\n/*.video-container:hover {*/\n/*    background-color: #FFF;*/\n/*    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.5)*/\n/*}*/\n\n/*.video-container:hover .published-options {*/\n/*    display: block;*/\n\n/*}*/\n\n/*.video-container:hover .published-options p,*/\n/*.video-container:hover .published-options h5 {*/\n/*    color: #878787;*/\n/*}*/\n\n/*.video-container:hover .published-views {*/\n/*    display: none;*/\n/*}*/\n\n.published-options {\n    /* display: none; */\n    list-style-type: none;\n}\n\n.published-options p, h5 {\n    color: #000000;\n}\n\n.published-options p {\n    margin-bottom: 0px;\n    margin-top: 0;\n}\n\n.published-options h5 {\n    margin-top: 0;\n    margin-bottom: 35px;\n}\n\n.published-options li a:hover {\n    color: #6c2fbb;\n}\n\n\nh5 {\n    margin-top: 15px;\n}\n\n.poster {\n    /*width: 100%;*/\n    /* height: 100%; */\n    cursor: pointer;\n}\n\n/***********************new************************/\n.video-title {\n    /*margin-bottom: 20px;*/\n    font-weight: 500;\n    font-size: 20px;\n    margin-top: 10px;\n}\n\n.cateogyclass {\n    padding: 5px 17px;\n    margin-top: 10px;\n    font-size: 14px;\n    font-weight: 400;\n    background: #FFFFFF;\n    border-radius: 12px;\n}\n\n.tab-box-video {\n    width: 100%;\n\n}\n\n.tab-box-video ul {\n    display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n}\n\n.tab-box-video ul li {\n    list-style: none;\n    font-weight: 500;\n    font-size: 18px;\n    padding: 5px 0;\n    margin: 0px 25px;\n    color: #878395;\n    cursor: pointer;\n}\n\n.tab-box-video ul li svg {\n    fill: #878395;\n}\n\n.tab-box-video ul li.active {\n    border-top: 3px solid #6c2fbb;\n    color: #6c2fbb;\n}\n\n.tab-box-video ul li.active svg {\n    fill: rgba(108, 47, 187, 1);\n}\n\n.video-container {\n    padding: 30px;\n    border-radius: 10px;\n    background-color: #ffff;\n    height: 66vh;\n    /*margin-top: 40px;*/\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n\n.img-box-pub {\n    aspect-ratio: 16/9;\n    display: flex;\n    justify-content: center;\n    /*height: 213px;*/\n    position: relative;\n    overflow: hidden;\n    background: #f8f9fa;\n    border-radius: 10px;\n    width: 100%;\n}\n\n.img-box-pub img {\n    height: 100%;\n    object-fit: cover;\n    cursor: pointer;\n}\n\n.two-btns {\n    position: absolute;\n    top: 0;\n    right: 0;\n    background-color: #000000a2;\n    display: flex;\n    align-items: center;\n    column-gap: 10px;\n    padding: 2px 10px;\n    border-radius: 5px 10px;\n}\n\n.two-btns button {\n    background-color: transparent;\n    display: flex;\n    align-items: center;\n    column-gap: 5px;\n    border: none;\n}\n\n.two-btns button span {\n    color: #fff;\n    font-size: 17px !important;\n}\n\n.width-100 {\n    width: 100%;\n    padding: 15px 0;\n    margin: 5px 0;\n    cursor: pointer;\n}\n\n.width-100:hover {\n    background-color: #f8f9fa;\n    box-shadow: 0 0 2px 0 rgb(0 0 0 / 50%);\n}\n\n@media (max-width: 1600px) {\n\n    .img-box-pub {\n        height: 150px\n    }\n\n}\n\n@media (max-width: 1400px) {\n    .group-box .two-btns {\n        position: absolute;\n        top: 5px;\n        right: 5px;\n\n    }\n\n    .group-box .two-btns button span {\n        font-size: 15px !important;\n    }\n\n    .tab-box-video ul li {\n        font-size: 18px;\n        white-space: nowrap;\n    }\n\n    .img-box-pub {\n        height: 120px;\n    }\n\n    .video-title {\n        font-size: 18px;\n    }\n}\n\n@media (max-width: 1200px) {\n    .tab-box-video ul {\n        overflow-x: auto;\n        padding-bottom: 10px;\n\n    }\n\n    .tab-box-video ul::-webkit-scrollbar {\n        height: 7px;\n    }\n\n\n}\n\n@media (max-width: 991px) {\n\n    .video-container {\n        padding: 12px;\n    }\n\n    .img-box-pub {\n        height: 240px;\n    }\n}\n\n@media (max-width: 768px) {\n\n    .tab-box-video ul li {\n        font-size: 17px;\n    }\n\n    .img-box-pub {\n        height: 157px;\n    }\n\n    .video-title {\n        font-size: 17px;\n    }\n}\n\n@media (max-width: 420px) {\n    .video-title {\n        font-size: 15px;\n    }\n\n    .img-box-pub {\n        height: 180px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
